import { ApiRoutes } from '../constant/api';
import { api } from '../helpers/axios';
import {
	IScudCompany,
	IScudFederationEmployee,
	IScudMappingDetails,
	IScudMappingList,
	IScudMappingPermissions,
	IScudMappingReason,
	IScudPersonExclusion,
	IScudUnit,
	TScudExclusionListQuery,
	TScudFederationSearchParams,
	TScudMappingListQuery,
	TScudMappingReasonRequest,
	TScudMappingUpdateRequest,
	TScudPersonExclusionList,
	TScudPersonExclusionRequest,
} from '../types/scudMapping.types';

// Бэкенд ждёт массивы повторяющимся параметром (status=1&status=3), а не status[]=1
const repeatArrays = { indexes: null };

export const scudMappingApi = {
	getPermissions: () =>
		api
			.get<IScudMappingPermissions>(`${ApiRoutes.ScudMapping}/permissions`)
			.then((res) => res.data),
	getList: (query: TScudMappingListQuery) =>
		api
			.get<IScudMappingList>(ApiRoutes.ScudMapping, {
				params: query,
				paramsSerializer: repeatArrays,
			})
			.then((res) => res.data),
	get: (id: number) =>
		api.get<IScudMappingDetails>(`${ApiRoutes.ScudMapping}/${id}`).then((res) => res.data),
	confirm: ({ id, version }: { id: number; version: number }) =>
		api
			.post<IScudMappingDetails>(`${ApiRoutes.ScudMapping}/${id}/confirm`, { version })
			.then((res) => res.data),
	update: ({ id, payload }: { id: number; payload: TScudMappingUpdateRequest }) =>
		api.put<IScudMappingDetails>(`${ApiRoutes.ScudMapping}/${id}`, payload).then((res) => res.data),

	getReasons: (onlyActive: boolean) =>
		api
			.get<IScudMappingReason[]>(`${ApiRoutes.ScudMapping}/reason`, {
				params: { only_active: onlyActive },
			})
			.then((res) => res.data),
	createReason: (payload: TScudMappingReasonRequest) =>
		api
			.post<IScudMappingReason>(`${ApiRoutes.ScudMapping}/reason`, payload)
			.then((res) => res.data),
	updateReason: ({ id, payload }: { id: string; payload: TScudMappingReasonRequest }) =>
		api
			.put<IScudMappingReason>(`${ApiRoutes.ScudMapping}/reason/${id}`, payload)
			.then((res) => res.data),

	searchFederation: (params: TScudFederationSearchParams) =>
		api
			.get<IScudFederationEmployee[]>(`${ApiRoutes.ScudMapping}/federation/search`, { params })
			.then((res) => res.data),
	getCompanies: () =>
		api.get<IScudCompany[]>(`${ApiRoutes.ScudMapping}/federation/company`).then((res) => res.data),
	getUnits: (companyId: number) =>
		api
			.get<IScudUnit[]>(`${ApiRoutes.ScudMapping}/federation/company/${companyId}/unit`)
			.then((res) => res.data),

	getExclusions: (params: TScudExclusionListQuery) =>
		api
			.get<TScudPersonExclusionList>(`${ApiRoutes.ScudMapping}/exclusion`, { params })
			.then((res) => res.data),
	createExclusion: (payload: TScudPersonExclusionRequest) =>
		api
			.post<IScudPersonExclusion>(`${ApiRoutes.ScudMapping}/exclusion`, payload)
			.then((res) => res.data),
	updateExclusion: ({ id, payload }: { id: number; payload: TScudPersonExclusionRequest }) =>
		api
			.put<IScudPersonExclusion>(`${ApiRoutes.ScudMapping}/exclusion/${id}`, payload)
			.then((res) => res.data),
	deleteExclusion: (id: number) => api.delete(`${ApiRoutes.ScudMapping}/exclusion/${id}`),
};
